import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import Loaders from '@/product/components/molecules/Loaders'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import moment from 'moment'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CouponContext from '@/product/context/coupon/couponContext'
import UserContext from '@/product/context/user/userContext'

let randomVariable = Math.random()

const CouponManage = (props) => {
    const couponContext = useContext(CouponContext)
    const {
        all_users,
        getAllUsers,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(UserContext)
    const { getSingleCoupon, search_single_coupon, couponAction } =
        couponContext
    const [usersList, setUsersList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    function generateCouponCode() {
        const length = 10
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        let coupon = ''

        let hasNumber = false

        let hasChar = false

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length)
            const randomChar = charset[randomIndex]

            if ('0123456789'.includes(randomChar)) {
                hasNumber = true
            }

            if ('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.includes(randomChar)) {
                hasChar = true
            }

            coupon += randomChar
        }

        if (!hasNumber || !hasChar) {
            return generateCouponCode()
        }

        return coupon
    }

    const [product, setProduct] = useState(null)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        code: Yup.mixed().required('Required!'),
        discount: Yup.mixed().required('Required!'),
        coupon_start_date: Yup.date('Please enter valid date!')
            .nullable()
            .required('Required!'),
        minimum_cart_value: Yup.number().when(['discount_type'], {
            is: (a) => a == 'percentage',
            then: Yup.number()
                .positive('Must be greater than zero')
                .required('Required'),
        }),
        maximum_discount_value: Yup.number().when(['discount_type'], {
            is: (a) => a == 'percentage',
            then: Yup.number()
                .positive('Must be greater than zero')
                .required('Required'),
        }),
        coupon_end_date: Yup.date('Please enter valid date!')
            .min(
                Yup.ref('coupon_start_date'),
                'Should be greater than start date'
            )
            .nullable()
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            code: '',
            discount: '',
            discount_type: 'amount',
            coupon_start_date: '',
            user_id: [],
            coupon_end_date: '',
            description: '',
            defaultAddition: true,
            apply_for: 'both',
            enabled: 1,
            coupon_type: 'public',
            minimum_cart_value: '',
            maximum_discount_value: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.coupon_start_date) {
                values.coupon_start_date = moment(
                    values.coupon_start_date,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
            if (values.coupon_end_date) {
                values.coupon_end_date = moment(
                    values.coupon_end_date,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }

            couponAction(values)
            setIsLoading(true)
        },
    })

    const optionFunc = (data) => {
        if (Array.isArray(data)) {
            randomVariable = Math.random()
            getAllUsers(
                {
                    limit: 20,
                    page: 1,
                    orderby: '',
                    order: '',
                    filters: {
                        status: {
                            value: 'active',
                            type: 'in',
                            field: 'u.status',
                        },
                        admin: {
                            value: '0',
                            type: 'in',
                            field: 'u.admin',
                        },
                        username: {
                            value: data,
                            type: 'array',
                            field: 'u.id',
                        },
                    },
                },
                randomVariable
            )
        } else {
            randomVariable = Math.random()
            getAllUsers(
                {
                    limit: 20,
                    page: 1,
                    orderby: '',
                    order: '',
                    filters: {
                        status: {
                            value: 'active',
                            type: 'in',
                            field: 'u.status',
                        },
                        admin: {
                            value: '0',
                            type: 'in',
                            field: 'u.admin',
                        },
                        username: {
                            value: data,
                            type: 'like',
                            field: 'u.first_name,u.last_name,u.email',
                        },
                    },
                },
                randomVariable
            )
        }
    }

    useEffect(() => {
        if (data.status === 'edit') {
            setIsLoading(true)
            setUsersList([])
            formik.values.id = data.id
            formik.values.code = ''
            getSingleCoupon(formik.values)
        } else {
            setUsersList([])
            resetFrom()
            setIsLoading(false)
        }
    }, [data])

    useEffect(() => {
        setUsersList([])
        setIsLoading(false)
    }, [])

    useEffect(() => {
        if (search_single_coupon.record && data.status === 'edit') {
            const template = search_single_coupon.record.length
                ? search_single_coupon.record[0]
                : {}

            setProduct(template)
            formik.values.id = template.id
            formik.values.code = template.code
            formik.values.discount = template.discount
            formik.values.user_id = template.user_id
                ? template.user_id.split(',').map(Number)
                : []
            formik.values.minimum_cart_value = template.minimum_cart_value
            formik.values.maximum_discount_value =
                template.maximum_discount_value
            formik.values.coupon_start_date = dateTimeFormatFunction(
                template.coupon_start_date
            )
            formik.values.coupon_end_date = dateTimeFormatFunction(
                template.coupon_end_date
            )
            formik.values.discount_type = template.discount_type
            formik.values.coupon_type = template.coupon_type
            formik.values.description = template.description
            formik.values.apply_for = template.apply_for
            setIsLoading(false)
        } else {
            resetFrom()
            setIsLoading(false)
        }
    }, [search_single_coupon])

    useEffect(() => {
        if (all_users && all_users.from == randomVariable) {
            setUsersList(all_users.records.length ? all_users.records : [])
        } else {
            setUsersList([])
        }
    }, [all_users])

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.code = generateCouponCode()
        formik.values.discount = ''
        formik.values.coupon_start_date = ''
        formik.values.coupon_end_date = ''
        formik.values.description = ''
        formik.values.apply_for = ''
        formik.values.user_id = []
        formik.values.minimum_cart_value = 0
        formik.values.maximum_discount_value = 0
        setProduct(null)
        formik.handleReset()
    }

    const emailTemplate = []

    emailTemplate.push(
        {
            label: 'Coupon Code',
            placeholder: 'Enter Coupon Code',
            class: 'col-12',
            type: 'text',
            shrink: true,
            name: 'code',
            formik: formik,
        },
        {
            label: 'Discount Type',
            placeholder: 'Select Discount Type',
            class: 'col-6',
            type: 'select',
            options: [
                { value: 'amount', show: 'Amount' },
                { value: 'percentage', show: 'Percentage' },
            ],
            name: 'discount_type',
            formik: formik,
        },
        {
            label: `Discount ${
                formik.values.discount_type === 'amount'
                    ? 'Amount'
                    : 'Percentage'
            }`,
            placeholder: `Enter Discount ${
                formik.values.discount_type === 'amount'
                    ? 'Amount'
                    : 'Percentage'
            }`,
            class: 'col-6',
            type: 'number',
            shrink: true,
            name: 'discount',
            formik: formik,
        },

        {
            label: 'Coupon Start',
            placeholder: 'Enter Coupon Start date',
            type: 'datetime',
            disablePast: true,
            class: 'col-md-3 col-sm-6 col-12',
            name: 'coupon_start_date',
        },
        {
            label: 'Coupon End',
            placeholder: 'Enter Coupon End date',
            type: 'datetime',
            disablePast: true,
            class: 'col-md-3 col-sm-6 col-12',
            name: 'coupon_end_date',
        },
        {
            label: 'Coupon Type',
            placeholder: 'Select Coupon Type',
            class: 'col-6',
            type: 'select',
            options: [
                { value: 'public', show: 'Public' },
                { value: 'restricted', show: 'Restricted' },
            ],
            name: 'coupon_type',
            formik: formik,
        },
        {
            label: 'Select Buyers',
            type: 'searchdrop',
            placeholder: 'Select Buyer',
            class: `col-md-4 col-sm-6 col-12 ${
                formik.values.coupon_type == 'restricted' ? '' : 'd-none'
            }`,
            name: 'user_id',
            multiple: true,
            getAllOptions: optionFunc,
            options: usersList.map((maincat) => {
                let categoryChanged = {}
                categoryChanged.show = maincat.email
                categoryChanged.value = maincat.id
                return categoryChanged
            }),
            formik: formik,
        },

        // {
        //     label: 'Coupon Apply For',
        //     placeholder: 'Select Coupon Appply For',
        //     class: 'col-md-3 col-sm-6 col-12',
        //     type: 'select',
        //     options: [
        //         { value: 'use_credit', show: 'Use Credit' },
        //         { value: 'registration', show: 'Registration' },
        //         { value: 'both', show: 'Both' },
        //     ],
        //     name: 'apply_for',
        //     formik: formik,
        // },

        {
            label: 'Minimum Cart Value',
            placeholder: 'Enter Minimum Cart Value',
            class: 'col-6',
            type: 'number',
            // shrink: true,
            name: 'minimum_cart_value',
            formik: formik,
        },
        {
            label: 'Maximum Discount Value',
            placeholder: 'Enter Maximum Discount Value',
            class: 'col-6',
            type: 'number',
            // shrink: true,
            name: 'maximum_discount_value',
            formik: formik,
        },
        {
            label: 'Coupon Notes',
            placeholder: 'Enter Coupon Notes',
            class: 'col-12',
            type: 'textarea',
            shrink: true,
            name: 'description',
            formik: formik,
        }
    )

    return (
        <FullScreenPopup
            modaltitle={data.status === 'new' ? 'ADD COUPON' : `EDIT COUPON`}
            open={data.popup}
            handleClose={() => {
                setUsersList([])
                toggleFullScreenPopup(false)
            }}
        >
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <div className="addUserModal">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {Object.values(mapData(emailTemplate))}
                            </div>

                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="configManage_cancel"
                                    label="Cancel"
                                    onClick={() => {
                                        toggleFullScreenPopup(false)
                                        setUsersList([])
                                    }}
                                />
                                <PrimaryButton
                                    id="configManage_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </FullScreenPopup>
    )
}

export default CouponManage
